var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-modal",
        {
          attrs: {
            title: "打印预览 - " + _vm.reportTitle,
            width: 900,
            visible: _vm.visible,
            maskClosable: false,
            forceRender: true,
            footer: null,
            fullscreen: "",
            switchFullscreen: "",
            wrapClassName: "sales-ranking-print-modal",
          },
          on: { cancel: _vm.handleCancel },
        },
        [
          _c(
            "div",
            {
              staticClass: "print-toolbar",
              staticStyle: {
                display: "flex",
                "align-items": "center",
                gap: "8px",
                "margin-bottom": "12px",
              },
            },
            [
              _c(
                "a-button",
                {
                  key: "templateSetting",
                  attrs: { icon: "setting", disabled: _vm.autoPrint },
                  on: { click: _vm.handleTemplateSetting },
                },
                [_vm._v("模板设置")]
              ),
              _c(
                "a-button",
                {
                  key: "printPreview",
                  attrs: { type: "primary", icon: "printer" },
                  on: { click: _vm.handlePrint },
                },
                [_vm._v("打印")]
              ),
              _c(
                "a-button",
                {
                  key: "exportPdf",
                  attrs: { icon: "file-pdf" },
                  on: { click: _vm.handleExportPdf },
                },
                [_vm._v("导出PDF")]
              ),
              _c(
                "a-checkbox",
                {
                  on: { change: _vm.onAutoPrintChange },
                  model: {
                    value: _vm.autoPrint,
                    callback: function ($$v) {
                      _vm.autoPrint = $$v
                    },
                    expression: "autoPrint",
                  },
                },
                [_vm._v("自动")]
              ),
            ],
            1
          ),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.loading, tip: "正在加载模板..." } },
            [
              !_vm.templateJson && !_vm.loading
                ? _c(
                    "div",
                    { staticClass: "no-template" },
                    [_c("a-empty", { attrs: { description: "暂无打印模板" } })],
                    1
                  )
                : _c("div", { staticClass: "preview-wrapper" }, [
                    _c("div", {
                      ref: "printContent",
                      staticClass: "print-content",
                    }),
                  ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }